import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HelmetProvider } from "react-helmet-async";
import "@/index.css";
import App from "@/App";
import { SeoProvider } from "@/context/SeoContext";
import { SiteContentProvider } from "@/context/ContentContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <SeoProvider>
          <SiteContentProvider>
            <App />
          </SiteContentProvider>
        </SeoProvider>
      </QueryClientProvider>
    </HelmetProvider>
  </React.StrictMode>,
);
